import Vue from 'vue'
import App from './App.vue'
import router from './router/index'; 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Nav from "./components/nav.vue";
import Clas from "./components/clas.vue";
// 把Nav组件注册为全局组件
Vue.component('Nav', Nav);
Vue.component('Clas', Clas);

Vue.config.productionTip = false
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
